export default __webpack_public_path__ + "static/media/639.84fbeefc.png";